import { index, analyticCategories, updateReportMonth } from '../../services/reports/reports'
import Vue from 'vue'

export const reports = {

  namespaced: 'reports',

  state: {
    data: {
      integrations: {
        errors: []
      },
      orders: [],
      financial: {},
      orders_daily: {},
      from: null,
      to: null,
      analytic_categories: [],
      month_headers: []
    },
    from: null,
    to: null,
    details: {},
    loading: true,
    error: null
  },

  actions: {

    index ({ state, commit }, data) {
      index(data)
        .then(response => {
          commit('setData', response.data)
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
        })
    },

    analyticCategories ({ state, commit }, data) {
      analyticCategories(data)
        .then(response => {
          commit('setAnalyticData', response.data)
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
        })
    },

    updateReportMonth ({ state, commit, dispatch }, data) {
      commit('setLoading', true)
      updateReportMonth(data)
        .then(response => {
          commit('setLoading', false)

          Vue.toasted.success('Valor salvo com sucesso!')

          dispatch('index', {
            types: ['orders-daily', 'orders-financial', 'integrations-errors', 'last-order'],
            from: null,
            to: null
          })
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)

          Vue.toasted.error('Erro ao salvar valor!')
        })
    }

  },

  mutations: {

    setData (state, data) {
      state.data = {
        ...state.data,
        from: data.from,
        to: data.to,
        financial: data.reports.financial,
        orders_daily: data.reports.orders_daily,
        integrations: data.reports.integrations,
        orders: data.reports.orders
      }
    },

    setAnalyticData (state, data) {
      state.data = {
        ...state.data,
        analytic_categories: data.analytic_categories,
        month_headers: data.month_headers
      }
    },

    setDetails (state, category) {
      state.details = category
    },

    setLoading (state, status) {
      state.loading = status
    },

    setError (state, error) {
      if (error.status === 401) {
        localStorage.clear()
        window.location.href = './login'
      }
    }

  },

  getters: {}

}
